/* eslint-disable @typescript-eslint/no-unused-vars,@typescript-eslint/no-use-before-define,@typescript-eslint/naming-convention,@typescript-eslint/no-use-before-define */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as types from './graphql';

/**
 * Map of all GraphQL operations in the project.
 *
 * This map has several performance disadvantages:
 * 1. It is not tree-shakeable, so it will include all operations in the project.
 * 2. It is not minifiable, so the string of a GraphQL query will be multiple times inside the bundle.
 * 3. It does not support dead code elimination, so it will add unused operations.
 *
 * Therefore it is highly recommended to use the babel or swc plugin for production.
 */
const documents = {
  '\n  fragment CompanyUserFragment on CompanyUser {\n    company {\n      name\n    }\n    companyMembershipRole\n    deletedAt\n    createdAt\n    UUID\n    user {\n      firstName\n      lastName\n      email\n    }\n  }\n':
    types.CompanyUserFragmentFragmentDoc,
  '\n  query CompanyUsersForCompanyHook($companyName: String!) {\n    companyUsers(companySlug: $companyName) {\n      ...CompanyUserFragment\n    }\n  }\n':
    types.CompanyUsersForCompanyHookDocument,
  '\n  query GetCompanyUser($uuid: UUID!, $input: GetCompanyUserInput!) {\n    companyUser(companyUserUUID: $uuid, input: $input) {\n      ...CompanyUserFragment\n    }\n  }\n':
    types.GetCompanyUserDocument,
};

/**
 * The graphql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 *
 *
 * @example
 * ```ts
 * const query = graphql(`query GetUser($id: ID!) { user(id: $id) { name } }`);
 * ```
 *
 * The query argument is unknown!
 * Please regenerate the types.
 */
export function graphql(source: string): unknown;

/**
 * The graphql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 */
export function graphql(
  source: '\n  fragment CompanyUserFragment on CompanyUser {\n    company {\n      name\n    }\n    companyMembershipRole\n    deletedAt\n    createdAt\n    UUID\n    user {\n      firstName\n      lastName\n      email\n    }\n  }\n',
): (typeof documents)['\n  fragment CompanyUserFragment on CompanyUser {\n    company {\n      name\n    }\n    companyMembershipRole\n    deletedAt\n    createdAt\n    UUID\n    user {\n      firstName\n      lastName\n      email\n    }\n  }\n'];
/**
 * The graphql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 */
export function graphql(
  source: '\n  query CompanyUsersForCompanyHook($companyName: String!) {\n    companyUsers(companySlug: $companyName) {\n      ...CompanyUserFragment\n    }\n  }\n',
): (typeof documents)['\n  query CompanyUsersForCompanyHook($companyName: String!) {\n    companyUsers(companySlug: $companyName) {\n      ...CompanyUserFragment\n    }\n  }\n'];
/**
 * The graphql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 */
export function graphql(
  source: '\n  query GetCompanyUser($uuid: UUID!, $input: GetCompanyUserInput!) {\n    companyUser(companyUserUUID: $uuid, input: $input) {\n      ...CompanyUserFragment\n    }\n  }\n',
): (typeof documents)['\n  query GetCompanyUser($uuid: UUID!, $input: GetCompanyUserInput!) {\n    companyUser(companyUserUUID: $uuid, input: $input) {\n      ...CompanyUserFragment\n    }\n  }\n'];

export function graphql(source: string) {
  return (documents as any)[source] ?? {};
}

export type DocumentType<TDocumentNode extends DocumentNode<any, any>> =
  TDocumentNode extends DocumentNode<infer TType, any> ? TType : never;
